export const VOLUME_ITEMS = [
  { key: 'concept_model' as const, label: '概念モデル' },
  { key: 'demands' as const, label: '要求' },
  { key: 'requirements' as const, label: '要件' },
  { key: 'business_flow_steps' as const, label: '業務フロー' },
  { key: 'permission_matrix' as const, label: '権限マトリクス' }
]

export const RISK_LEVEL_META: Record<'low' | 'medium' | 'high', { label: string, color: string }> = {
  low: { label: '低リスク', color: 'var(--bp-ok)' },
  medium: { label: '要注意', color: 'var(--bp-warning)' },
  high: { label: '高リスク', color: 'var(--bp-critical)' }
}
